import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Separator } from '../ui/separator';
import { Badge } from '../ui/badge';

const VisaTab = ({ formData, updateDeskField, masterData, readOnly = false }) => {
  const data = formData.visa || {};
  const update = (field, value) => {
    if (readOnly) return;
    updateDeskField('visa', field, value);
  };
  const users = masterData.users || [];

  const renderUserOptions = () => users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-primary">Visa Officer</CardTitle>
        <CardDescription>
          Visa application details
          {readOnly && <Badge variant="outline" className="ml-2">View Only - You don't have permission to edit this desk</Badge>}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <Label>Visa Officer</Label>
            <Select value={data.visa_officer || 'none'} onValueChange={(v) => update('visa_officer', v === 'none' ? '' : v)} disabled={readOnly}>
              <SelectTrigger><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select</SelectItem>
                {renderUserOptions()}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Visa Type</Label>
            <Select value={data.visa_type || 'none'} onValueChange={(v) => update('visa_type', v === 'none' ? '' : v)} disabled={readOnly}>
              <SelectTrigger data-testid="visa-type"><SelectValue placeholder="Select type" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select</SelectItem>
                <SelectItem value="student">Student Visa</SelectItem>
                <SelectItem value="visitor">Visitor Visa</SelectItem>
                <SelectItem value="work">Work Visa</SelectItem>
                <SelectItem value="dependent">Dependent Visa</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Travel Date</Label>
            <Input type="date" value={data.travel_date || ''} onChange={(e) => update('travel_date', e.target.value)} data-testid="visa-travel-date" readOnly={readOnly} />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <Label>Visa Application Date</Label>
            <Input type="date" value={data.application_date || ''} onChange={(e) => update('application_date', e.target.value)} readOnly={readOnly} />
          </div>
          <div className="space-y-2">
            <Label>Visa Decision</Label>
            <Select value={data.decision || 'none'} onValueChange={(v) => update('decision', v === 'none' ? '' : v)} disabled={readOnly}>
              <SelectTrigger data-testid="visa-decision"><SelectValue placeholder="Select decision" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select</SelectItem>
                <SelectItem value="not_applied">Not Applied</SelectItem>
                <SelectItem value="applied">Applied</SelectItem>
                <SelectItem value="approved">Approved</SelectItem>
                <SelectItem value="rejected">Rejected</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Visa Decision Date</Label>
            <Input type="date" value={data.decision_date || ''} onChange={(e) => update('decision_date', e.target.value)} readOnly={readOnly} />
          </div>
        </div>
        <Separator />
        <div className="space-y-2">
          <Label>Next of Kin Details</Label>
          <Textarea value={data.nok_details || ''} onChange={(e) => update('nok_details', e.target.value)} placeholder="Name, relationship, contact details..." rows={3} data-testid="visa-nok" readOnly={readOnly} />
        </div>
        <div className="space-y-2">
          <Label>Visa Notes</Label>
          <Textarea value={data.notes || ''} onChange={(e) => update('notes', e.target.value)} placeholder="Add any visa-related notes..." rows={4} data-testid="visa-notes" readOnly={readOnly} />
        </div>
      </CardContent>
    </Card>
  );
};

export default VisaTab;
